import React, { useEffect } from 'react'
import "./VendorDetailsOverview.css"
import axios from "axios";
import MiniDrawer from '../MiniDrawer/MiniDrawer'
import { useState } from 'react';
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ExcelExport from "../../components/ExcelExport/ExcelExportAccounts";
import filterIcon from "../../Icons/filterIcon.png";
import { useSearchParams } from "react-router-dom";
import { RsvpOutlined } from '@mui/icons-material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

function VendorDetailsOverview() {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const[authorized,setAuthorized]=useState(false)
  const[formData,setFormData]=useState(null)
const[AddressForm,setAddressForm]=useState(null)
const[OtherDetailForm,setOtherDetailForm]=useState(null)
const [currencies, setCurrencies] = useState([]);
const [gstTreatment, setGstTreatment] = useState(null);
  const [paymentTerms, setPaymentTerms] = useState(null);
  const [vendorPANType, setVendorPANType] = useState(null);
  const [supplySource, setSupplySource] = useState(null);
  const [openingBalance, setOpeningBalance] = useState(null);
  const [vendorTDS, setVendorTDS] = useState(null);
const [vendorDoc,setVendorDoc]=useState({
  GSTDocument: null,
  PANDocument: null,
  ChequeDocument: null,
  VRFDocument: null,
  MSMEDoc:null
})
const [searchParm] = useSearchParams();
const[vendorCategory,setVendorCategory]=useState(null)
const[SPCountry,setSPCountry]=useState(null)
const[BLCountry,setBLCountry]=useState(null)
const[SPCity,setSPCity]=useState(null)
const[BLCity,setBLCity]=useState(null)
const[SPState,setSPState]=useState(null)
const[BLState,setBLState]=useState(null)
const [BankDetailForm, setBankDetailForm] = useState(null)
const [ContactDetailForm, setContactDetailForm] = useState(null)
useEffect(() => {
  if (searchParm.get("vendorID") != null) {
    getCurrentVendorDetails(searchParm.get("vendorID"))
    getCurrentVendorAddressDetail(searchParm.get("vendorID") )
getCurrentVendorOtherDetails(searchParm.get("vendorID") )
getVendorBankDetail(searchParm.get("vendorID") )
getVendorContactDetails(searchParm.get("vendorID"))
  }
}, []);

function getCurrentVendorDetails(id) {
  const storedToken = JSON.parse(localStorage.getItem("token"));

  axios
    .get(`${baseAPI}admin/GETSupplier?SupplierID=${id}`)
    .then((response) => {
      if (searchParm.get("vendorID") === response.data.data[0].VendorGUID) {
      GetVendorCategory(response.data.data[0].VendorCategory)
        setAuthorized(true);
        setFormData(response.data.data[0])
      }
  
    })
    .catch((error) => {
      console.error("Error fetching user detail:", error);
    });
}

function GetVendorCategory(id) {
  axios
    .get(`${baseAPI}Admin/GetVendorCategory`, {
      // headers: {
      //   Authorization: `Bearer ${storedToken}`,
      // },
    })
    .then((response) => {
      response.data.data.map(item=>{
        if(item.Tseed==id){
          setVendorCategory(item.Category_Name);
        }
      })
    })
    .catch((error) => {
      console.error("Error fetching user detail:", error);
    });
}

  function getCurrentVendorAddressDetail(id){
    const storedToken = JSON.parse(localStorage.getItem("token")
  );
    if(storedToken){
      axios
      .get(`${baseAPI}admin/GETVendorAddressGUID?VendorID=${id}`, {
        })
        .then((response) => {
                        if(response.data.data[0].VendorGUID!=null){
                          getCountry(response.data.data[0].BLCountry,1)
                          getCountry(response.data.data[0].SPCountry,2)
                          getState(response.data.data[0].BLState,response.data.data[0].BLCountry,1)
                          getState(response.data.data[0].SPState,response.data.data[0].SPCountry,2)
                          getCity(response.data.data[0].BLCity,response.data.data[0].BLState,1)
                          getCity(response.data.data[0].SPCity,response.data.data[0].SPState,2)
                          setAddressForm(response.data.data[0])
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })

    }
  };

  function getCountry(id,type) {
    
    axios
      .get(`${baseAPI}admin/GETCountry?countryID=${id}`, {
      })
      .then((response) => {
  const name=response.data.data[0].name
  if(name){
    if(type===1){
      setBLCountry(name)
    }
    else{
      setSPCountry(name)
    }
  }

      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getState(id,country_id,type) {
    if (country_id != null && country_id != "0") {
      axios
      .get(`${baseAPI}Admin/GETState?stateID=0&countryID=` + country_id, {
        
        })
        .then((response) => { 
          if(type===1){
            response.data.data.map(st=>{
              if(st.state_id===id){
                setBLState(st.stateName)
              }
            })
          }
          else{
            response.data.data.map(st=>{
              if(st.state_id===id){
                setSPState(st.stateName)
              }
            })          }
          
        });
    }
  }

  function getCity(id,state_id,type) {
    if (state_id != null && state_id != "0") {
      axios
        .get(`${baseAPI}Admin/GETCity?cityID=0&stateID=` + state_id, {

        })
        .then((response) => {
          if(type===1){
            response.data.data.map(st=>{
              if(st.id==id){
                setBLCity(st.name)
              }
            })
          }
          else{
            response.data.data.map(st=>{
              if(st.id==id){
                setSPCity(st.name)
              }
            })
          }         
             });
    }
  }

  function getCurrentVendorOtherDetails(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
if(storedToken){
  axios
    .get(`${baseAPI}admin/GETVendorDetailGUID?VendorID=${id}`, {})
    .then((response) => {
      if (response.data.data[0].VendorGUID != null) {
        getCurrency(parseInt(response.data.data[0].Currency))
        getGstTreatmentDetails(response.data.data[0].GstTreatment)
        getSupplySourceDetails(response.data.data[0].SupplySource)
        getOpeningBalanceDetails(response.data.data[0].OpeningBalance)
        getTDSDetails(response.data.data[0].TDS)
        getPANType(response.data.data[0].PAN_Type)
        getPaymentTermsDetails(response.data.data[0].PaymentTerms)
        setVendorDoc({
          GSTDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].GSTDocument}`,
          PANDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].PANDocument}`,
          ChequeDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].ChequeDocument}`,
          VRFDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].VRFDocument}`,
          MSMEDoc:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].MSMEDoc}`,
        })
        setOtherDetailForm(response.data.data[0])
      }
    })
    .catch((error) => {
      console.error("Error fetching user detail:", error);
    });
}
  }

  function getCurrency(id) {
    axios.get(`${baseAPI}Admin/GETCurrency`, {}).then((response) => {
      const data=response.data.data
      if(data!==null){
        data.map(curr=>{
          if(curr.CurrencyID===id){
            setCurrencies(curr.CurrencyName)
          }
        })
      }
    });
  }

  function getGstTreatmentDetails(id) {
    axios
      .get(`${baseAPI}Admin/GETVendorGSTTreatmentDetails`, {})
      .then((response) => {
        response.data.data.map(item=>{
          if(item.Tseed==id){
            setGstTreatment(item.GSTTreatment_Type);

          }
        })
      });
  }

  function getSupplySourceDetails(id) {
    axios
      .get(`${baseAPI}Admin/GETVendorSupplySourceDetails`, {})
      .then((response) => {
        response.data.data.map(item=>{
          if(item.Tseed==id){

            setSupplySource(item.State_Name);
          }
        })
      });
  }

  function getOpeningBalanceDetails(id) {
    axios
      .get(`${baseAPI}Admin/GETVendorOpeningBalanceDetails`, {})
      .then((response) => {
        response.data.data.map(item=>{
          if(item.Tseed==id){

            setOpeningBalance(item.OpeningBalance_Type);
            
          }
        })
      });
  }

  function getTDSDetails(id) {
    axios.get(`${baseAPI}Admin/GETVendorTDSDetails`, {}).then((response) => {
      response.data.data.map(item=>{
        if(item.Tseed==id){

          setVendorTDS(item.TDS_Category)
        }
      })
    });
  }

  function getPANType(id) {
    axios.get(`${baseAPI}Admin/GETVendorPANType`, {}).then((response) => {
      response.data.data.map(item=>{
        if(item.Tseed==id){
          setVendorPANType(item.PAN_Type);

        }
      })
    });
  }

  function getPaymentTermsDetails(id) {
    axios
      .get(`${baseAPI}Admin/GETVendorPaymentTermsDetails`, {})
      .then((response) => {
        response.data.data.map(item=>{
          if(item.Tseed==id){
            setPaymentTerms(item.Payment_Type);
  
          }
        })
      });
  }

  function getVendorBankDetail(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
if(storedToken){
  axios
    .get(`${baseAPI}admin/GETVendorBankGUID?VendorID=${id}`)
    .then((response) => {
      setBankDetailForm(response.data.data)
    })
    .catch((error) => {
      console.error("Error fetching user detail:", error);
    });
}
}

function getVendorContactDetails(id){
  const storedToken = JSON.parse(localStorage.getItem("token")
);
  if(storedToken){
    axios
    .get(`${baseAPI}admin/GETVendorContactGUID?VendorID=${id}`, {
      })
      .then((response) => {
                      setContactDetailForm(response.data.data)
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      })
};
  }

  function nextPage(){   
    const url = `/AddVendorDetails_Admin?vendorID=${searchParm.get("vendorID")}`;
    // const url = `/vendorDetailOverview?vendorID=${VendorGUID}`;
    window.open(url, '_self');
  }


    const isAdmin = localStorage.getItem("isAdmin");
    const [supplierDetailResponse, setSupplierDetailResponse] = useState(null);

  return (
    <div className="d-flex flex-row app">
    <MiniDrawer />
    <div
      className="container-fluid mt-4"
      style={{
        padding: "4rem 1rem 1rem 1rem",
        width: "94%",
        backgroundColor: "#F4F4F4",
      }}
    >
      <div
        className="d-flex flex-column w-100"
        style={{ backgroundColor: "#F4F4F4" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
              Vendor Details | <HomeOutlinedIcon />{" "}
              <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
              <span style={{ fontSize: "20px",paddingLeft:"10px" }}>&gt; Vendor Registration Form</span>
            </h1>

          </div>
        </div>
        <div>
          {authorized?
           <Wrapper className="ViewLeadDetails">
           <div style={{ display: "flex", justifyContent: "end" }}>
            
             <div style={{ display: "flex" }}
             ><p
               className="icon"
               style={{
                 textAlign: "center",
                 padding: "7px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "11rem",
                 height: "3rem",
                 borderRadius: "0.5rem",
                 color: "#6A6A6A",
                 backgroundColor: "white",
                 marginRight: "13px",
               }}
             >
                 {" "}
               </p>
               <button onClick={nextPage} style={{height: "47px",color:"#6a6a6a",
    width: "81px",
    marginRight: "18px"}}>
                <ModeEditIcon style={{color:"#6a6a6a"}}/>
                Edit</button>
               {isAdmin === "true" && (
                 <ExcelExport supplierDetailResponse={supplierDetailResponse} />)}
             </div>
           </div>
           <hr/>
           <h2
             className="Venderheading"
             style={{
               fontSize: "22px",
               paddingLeft: "16px",
               paddingTop: "7px",
             }}
           >
             Vendor Details
           </h2>
           {/* Vendor Details  */}
           <div className='mt-4'>
           <h4
           style={{
             fontSize: "15px",
             fontWeight: "bold",
             
           }}
           className="mt-4 relocation-heading2 px-1"
         >
           <span style={{
             fontSize: "18px",
             fontWeight: "bold",
             padding: "10px 18px 10px 18px",
             padding:"0px",
             color:"#5B489D"
           }} className="text-start" >
           Vendor Details{" "}            </span>
         </h4>
         <div className='px-1'>
         <hr style={{margin:"0px"}} />
         </div>
           <div style={{paddingBottom:"0px"}} className="relocation-details-main-form px-2">
          <div className="form-row row align-items-center px-2">
           
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>First Name</h4>
              {formData!==null?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.VendorFirstName}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Last Name</h4>
              {formData!==null?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.VendorLastName}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Company Name</h4>
              {formData!==null && formData.CompanyName?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.CompanyName}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Vendor Display Name</h4>
              {formData!==null && formData.DisplayName?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.DisplayName}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
          </div>
          
          <div className="form-row row align-items-center px-2">
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Vendor Email</h4>
              {formData!==null?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.VendorEmail}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Vendor Category</h4>
              {formData!==null && vendorCategory?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{vendorCategory}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Vendor Phone 1</h4>
              {formData!==null && formData.Phone1?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.Phone1}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }             
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Vendor Phone 2</h4>
              {formData!==null && formData.Phone2?
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{formData.Phone2}</h4>
            :
            <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }             
            </div>
          </div>
         
        </div>
           </div>
           {/* Address Details  */}
           <div className='mt-4'>
           <h4
           style={{
             fontSize: "15px",
             fontWeight: "bold",
             
           }}
           className="mt-4 relocation-heading2 px-1"
         >
           <span style={{
             fontSize: "18px",
             fontWeight: "bold",
             padding: "10px 18px 10px 18px",
             padding:"0px",
             color:"#5B489D"
           }} className="text-start" >
           Address{" "}            </span>
         </h4>
         <div className='px-1'>
         <hr style={{margin:"0px"}} />
         </div>
         <div className='row px-3'>
         <div style={{paddingBottom:"0px"}} className="relocation-details-main-form px-0 col-6 ">
           <h4 className='px-0 mt-3' style={{fontSize:"18px",color:"#6A6A6A"}}>Blling Address</h4>
          <div className="form-row row align-items-start px-3">  
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Attention</h4>
            {AddressForm!==null && AddressForm.BLAttention?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLAttention}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }
            </div>
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Country/Region</h4>
              {AddressForm!==null && AddressForm.BLCountry?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{BLCountry}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }             </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>State</h4>
              {AddressForm!==null && AddressForm.BLState?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{BLState}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   </div>
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>City</h4>
              {AddressForm!==null && AddressForm.BLCity?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{BLCity}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Address</h4>
              {AddressForm!==null && AddressForm.BLAddress1 ?
              <>
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLAddress1}</h4>
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLAddress2}</h4>
              </>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }             
                </div>
       
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Pin Code</h4>
              {AddressForm!==null?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLPincode}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   
            </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Phone</h4>
              {AddressForm!==null && AddressForm.BLPhone?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLPhone}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   </div>
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Fax Number</h4>
              {AddressForm!==null && AddressForm.BLFaxNumber?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.BLFaxNumber}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                     
            </div>
          </div>
        </div>
        <div style={{paddingBottom:"0px"}} className="relocation-details-main-form px-0 col-6 ">
           <h4 className='px-0 mt-3' style={{fontSize:"18px",color:"#6A6A6A"}}>Shipping Address</h4>
          <div className="form-row row align-items-start px-3">  
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Attention</h4>
              {AddressForm!==null && AddressForm.SPAttention?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPAttention}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   </div>
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Country/Region</h4>
              {AddressForm!==null && AddressForm.SPCountry?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{SPCountry}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                   </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>State</h4>
              {AddressForm!==null && AddressForm.SPState?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{SPState}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }               </div>
         
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>City</h4>
              {AddressForm!==null && AddressForm.SPCity?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{SPCity}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }               </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Address</h4>
              {AddressForm!==null && AddressForm.SPAddress1?
              <>
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPAddress1}</h4>
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPAddress2}</h4>
           </>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }                     </div>
        
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Pin Code</h4>
              {AddressForm!==null && AddressForm.SPPincode?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPPincode}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }               </div>
          </div>
          <div className="form-row row align-items-start px-3">
          <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Phone</h4>
              {AddressForm!==null && AddressForm.SPPhone?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPPhone}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }               </div>
            <div className=" col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Fax Number</h4>
              {AddressForm!==null && AddressForm.SPFaxNumber!==null?
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{AddressForm.SPFaxNumber}</h4>
           :
           <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
           }               
            </div>
          </div>
        </div>
         </div>
         
           </div>
            {/* Other Details  */}
            <div className='mt-4'>
           <h4
           style={{
             fontSize: "15px",
             fontWeight: "bold",
             
           }}
           className="mt-4 relocation-heading2 px-1"
         >
           <span style={{
             fontSize: "18px",
             fontWeight: "bold",
             padding: "10px 18px 10px 18px",
             padding:"0px",
             color:"#5B489D"
           }} className="text-start" >
           Other Details{" "}            </span>
         </h4>
         <div className='px-1'>
         <hr style={{margin:"0px"}} />
         </div>
           <div style={{paddingBottom:"0px"}} className="relocation-details-main-form px-2">
          <div className="form-row row align-items-center px-2">
           
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>GST Treatment              </h4>
              {OtherDetailForm!==null && OtherDetailForm.GstTreatment?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{gstTreatment}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Source Of Supply              </h4>
              {OtherDetailForm!==null && OtherDetailForm.SupplySource?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{supplySource}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>GST Number              </h4>
              {OtherDetailForm!==null && OtherDetailForm.GstNumber?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{OtherDetailForm.GstNumber}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>PAN</h4>
              {OtherDetailForm!==null && OtherDetailForm.PanNumber?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{OtherDetailForm.PanNumber}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
          </div>
          
          <div className="form-row row align-items-center px-2">
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Currency</h4>
              {OtherDetailForm!==null && OtherDetailForm.Currency?
                             <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{currencies}</h4>
               
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Opening Balance</h4>
              {OtherDetailForm!==null && OtherDetailForm.OpeningBalance?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{openingBalance}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}> Amount</h4>
              {OtherDetailForm!==null && OtherDetailForm.Amount?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{OtherDetailForm.Amount}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }              
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Payment Terms</h4>
              {OtherDetailForm!==null && OtherDetailForm.PaymentTerms?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{paymentTerms}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
          
          </div>
          <div className="form-row row align-items-center px-2">
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>TDS</h4>
              {OtherDetailForm!==null && OtherDetailForm.TDS?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{vendorTDS}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }             
            </div>
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>PAN Type</h4>
              {OtherDetailForm!==null && vendorPANType?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{vendorPANType}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>MSME Registered</h4>
              {OtherDetailForm!==null?
              OtherDetailForm.MSMERegistered?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>True</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>False</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }             
            </div>
            <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>MSME Number              </h4>
              {OtherDetailForm!==null && OtherDetailForm.MSMENumber?
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>{OtherDetailForm.MSMENumber}</h4>
          :
          <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
            }
            </div>
          </div>
          <div className="form-row row align-items-center px-2">
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>MSME Document</h4>
              {OtherDetailForm &&  OtherDetailForm.MSMEDoc?
                            <a target="_blank" href={vendorDoc.MSMEDoc} style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" ,paddingRight:"20px"}}>View Document</a>
              :
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
              }            </div>
             
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>GST Document</h4>
              {OtherDetailForm &&  OtherDetailForm.GSTDocument?
                            <a target="_blank" href={vendorDoc.GSTDocument} style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" ,paddingRight:"20px"}}>View Document</a>
              :
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
              }            </div>
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>PAN Document</h4>
              {OtherDetailForm &&  OtherDetailForm.PANDocument?
                            <a target="_blank" href={vendorDoc.PANDocument} style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" ,paddingRight:"20px"}}>View Document</a>
              :
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
              }
            </div>
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>Cheque Document</h4>
              {OtherDetailForm &&  OtherDetailForm.ChequeDocument?
                            <a target="_blank" href={vendorDoc.ChequeDocument} style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" ,paddingRight:"20px"}}>View Document</a>
              :
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
              }            </div>
         
                 
             
          </div>
          <div className="form-row row align-items-center px-2">
          <div className="col-md-3 col-6 p-0 text-start">
              <h4 style={{fontSize:"14px", color: "#6a6a6a", marginTop: "29px" }}>VRF Document</h4>
              {OtherDetailForm &&  OtherDetailForm.VRFDocument?
                            <a target="_blank" href={vendorDoc.VRFDocument} style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" ,paddingRight:"20px"}}>View Document</a>
              :
              <h4 style={{fontSize:"14px",  color: "#6a6a6a",fontWeight:"700" }}>-</h4>
              }            </div>
</div>
        </div>
           </div>
              {/* Bank Details  */}
              <div className='mt-4'>
           <h4
           style={{
             fontSize: "15px",
             fontWeight: "bold",
             
           }}
           className="mt-4 relocation-heading2 px-1"
         >
           <span style={{
             fontSize: "18px",
             fontWeight: "bold",
             padding: "10px 18px 10px 18px",
             padding:"0px",
             color:"#5B489D"
           }} className="text-start" >
           Bank Details{" "}            </span>
         </h4>
         <div className=''>
         <hr style={{margin:"0px"}} />
         </div>
         <div className="bank_details_list_main-div mt-4 px-1">
           <table style={{width:"100%"}} className={`vendor_type_contact_detail_list px-2`}>
          <thead>
            <tr className="supplierListHeading">
                <th >S.No.</th>
              <th >Account Holder Name</th>
              <th >Bank Name</th>
              <th >Account Number</th>
              <th >City</th>
            </tr>     
          </thead>
          <tbody>
            {BankDetailForm !== null ? (
              BankDetailForm.map((data, index) => (
                <tr key={index}>
                                      <td>{index+1}</td>
                  <td >{data.HolderName}</td>
                  <td >{data.BankName}</td>
                  <td >{data.AccountNum}</td>
                  <td >{data.City}</td>                  
                  </tr>
              ))
            ) : 
            
            (
              <tr>
                {/* {} */}
              </tr>
            )}
          </tbody>
        </table>
      
          

        </div>
           </div>
              {/* Contact Details  */}
              <div className='mt-4'>
           <h4
           style={{
             fontSize: "15px",
             fontWeight: "bold",
             
           }}
           className="mt-4 relocation-heading2 px-1"
         >
           <span style={{
             fontSize: "18px",
             fontWeight: "bold",
             padding: "10px 18px 10px 18px",
             padding:"0px",
             color:"#5B489D"
           }} className="text-start" >
           Contact Details{" "}            </span>
         </h4>
         <div className='px-1'>
         <hr style={{margin:"0px"}} />
         </div>
         <div className="container-fluid px-1 mt-4">
          <div className="contact_details_list_main-div">
          <table className={`vendor_type_contact_detail_list`} >
            
        <thead>
          <tr className="supplierListHeading">
          <th >S.No.</th>
            <th >Salutation</th>
            <th >First Name</th>
            <th >Last Name</th>
            <th >Email Address</th>
            <th >Work Phone</th>
            <th >Mobile</th>
           
            
          </tr>     
        </thead>
        <tbody>
          {ContactDetailForm!== null ? (
           ContactDetailForm.map((data, index) => (
              <tr key={index}>
                <td >{index+1}</td>
                <td >{data.Salutation}</td>
                <td >{data.FirstName}</td>
                <td >{data.LastName}</td>
                <td >{data.Email}</td>
                <td >{data.WorkPhone}</td>
                <td >{data.Mobile}</td>
              
                
                </tr>
            ))
          ) : (
            <tr>
            </tr>
          )}
        </tbody>
      </table>
          </div>
          </div>
           </div>
         </Wrapper>
        :
        <div className='px-2' style={{height:"100vh",boxShadow:"0 1px 8px rgba(0, 0, 0, 0.25)",borderRadius:"7px",backgroundColor:"white"}}>
          <h3 className='px-1 py-3'>You are not Authorized to open this</h3>  
        </div>
        }
         
        </div>
      </div>
    </div>
  </div>
  )
}

export default VendorDetailsOverview